var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0446 19.1457L22.0446 13.9076L16.1374 13.9076C14.6646 13.9076 13.4707 12.7137 13.4707 11.2409V5.33335H7.99935L7.99935 23.9999L15.9257 23.9999L16.9235 26.6665H6.66601C5.92963 26.6665 5.33267 26.0696 5.33267 25.3332L5.33267 4.00002C5.33267 3.26364 5.92963 2.66669 6.66601 2.66669L16.1893 2.66669L24.711 11.1884L24.7112 20.1435L29.7717 22.037L26.2212 25.5875L29.8352 29.2014L28.0907 30.9459L24.4768 27.3319L20.9339 30.8748L15.6498 16.753L22.0446 19.1457ZM20.9922 11.2409L16.1374 11.2409V6.38603L20.9922 11.2409Z",
    fill: "#6F757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.2a5eefb310e00e075a453b7e011b28f6.svg";
export { ForwardRef as ReactComponent };